import axios from "axios";
import { BASE_URL } from "../Constants/Options";

const axiosClient = axios.create({
    baseURL: BASE_URL,
    headers: {
        Accept: "application/json, text/plain, */*",
    },
});

const AxiosRequest = async (options) => {
    const onSuccess = (response) => {
        return response.data;
    };

    const onError = function (error) {
        return Promise.reject({
            message: error.message,
            code: error.code,
            response: error.response,
        });
    };

    return axiosClient(options).then(onSuccess).catch(onError);
};

export default AxiosRequest;
